import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types/index';

import { initialState } from './slice';

const selectDomain = (state: RootState) => state.remediation || initialState;

export const selectRemediation = createSelector(
  [selectDomain],
  remediationState => remediationState,
);
